import React from "react";
import styles from "./HomeLivemetrics.module.css";

function GeneralLiveMetrics({ metrics }) {
  // determine color coding for live metrics
  const determineColor = (
    metricValue,
    thresholdLow,
    thresholdHigh,
    metricProp
  ) => {
    if (metricProp === "fuel") {
      if (metricValue === 0) {
        return {
          backgroundColor: "#F1F1F1",
          iconColor: "#263238",
        };
      } else if (metricValue > 0 && metricValue < thresholdLow) {
        return {
          backgroundColor: "#FFDFD7",
          iconColor: "#FD4D1E",
        };
      } else if (metricValue <= thresholdHigh) {
        return {
          backgroundColor: "#FFF5CC",
          iconColor: "#FF9900",
        };
      } else {
        return {
          backgroundColor: "#D7FBDB",
          iconColor: "#008069",
        };
      }
    } else if (metricProp === "engine load") {
      if (metricValue === 0) {
        return {
          backgroundColor: "#F1F1F1",
          iconColor: "#263238",
        };
      } else if (
        metricValue > thresholdHigh &&
        metrics?.scan_data?.vehicle_live_data?.speed === 0
      ) {
        return {
          backgroundColor: "#FFDFD7",
          iconColor: "#FD4D1E",
        };
      } else if (
        metricValue < thresholdHigh &&
        metrics?.scan_data?.vehicle_live_data?.speed === 0
      ) {
        return {
          backgroundColor: "#FFF5CC",
          iconColor: "#FF9900",
        };
      } else {
        return {
          backgroundColor: "#D7FBDB",
          iconColor: "#008069",
        };
      }
    } else {
      if (metricValue === 0) {
        return {
          backgroundColor: "#F1F1F1",
          iconColor: "#263238",
        };
      } else if (metricValue > 0 && metricValue < thresholdLow) {
        return {
          backgroundColor: "#D7FBDB",
          iconColor: "#008069",
        };
      } else if (metricValue <= thresholdHigh) {
        return {
          backgroundColor: "#FFF5CC",
          iconColor: "#FF9900",
        };
      } else {
        return {
          backgroundColor: "#FFDFD7",
          iconColor: "#FD4D1E",
        };
      }
    }
  };

  //color code for overheating
  const determineOverheatingColor = (
    metricValue,
    thresholdLow,
    thresholdHigh
  ) => {
    if (metricValue === 0) {
      return {
        backgroundColor: "#F1F1F1",
        iconColor: "#263238",
      };
    } else if (metricValue > 0 && metricValue < thresholdLow) {
      return {
        backgroundColor: "#FFF5CC",
        iconColor: "#FF9900",
      };
    } else if (metricValue <= thresholdHigh) {
      return {
        backgroundColor: "#D7FBDB",
        iconColor: "#008069",
      };
    } else {
      return {
        backgroundColor: "#FFDFD7",
        iconColor: "#FD4D1E",
      };
    }
  };

  return (
    <div className={styles.home_live_metrics}>
      <div className={styles.head}>
        <div>
          <h3>Live Metrics</h3>
        </div>
      </div>
      <div className={styles.home_live_metrics_inner}>
        <div className={styles.fuel_container}>
          <div
            className={styles.fuel_tank}
            style={{
              backgroundColor: determineColor(
                parseFloat(
                  metrics?.scan_data?.vehicle_live_data?.remaining_fuel
                ),
                40,
                75,
                "fuel"
              ).backgroundColor,
              border: `3px solid ${
                determineColor(
                  parseFloat(
                    metrics?.scan_data?.vehicle_live_data?.remaining_fuel
                  ),
                  40,
                  75,
                  "fuel"
                ).iconColor
              }`,
            }}
          >
            <div
              className={styles.inner_bar}
              style={{
                backgroundColor: determineColor(
                  parseFloat(
                    metrics?.scan_data?.vehicle_live_data?.remaining_fuel
                  ),
                  40,
                  75,
                  "fuel"
                ).iconColor,
                height: `${
                  metrics
                    ? parseFloat(
                        metrics?.scan_data?.vehicle_live_data?.remaining_fuel
                      )
                    : 0
                }%`,
              }}
            ></div>
            <div className={styles.fuel_metrics}>
              <p>
                {metrics
                  ? parseFloat(
                      metrics?.scan_data?.vehicle_live_data?.remaining_fuel
                    )
                  : 0}
                %
              </p>
              <p>Fuel</p>
            </div>
          </div>
        </div>

        <div
          className={styles.metrics_card2}
          style={{
            backgroundColor: determineOverheatingColor(
              Number(
                metrics?.scan_data?.vehicle_live_data?.coolant_temperature
              ),
              80,
              91
            ).backgroundColor,
          }}
        >
          <div>
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_8824_1218)">
                <path
                  d="M12 1C11.6022 1 11.2206 1.15804 10.9393 1.43934C10.658 1.72064 10.5 2.10218 10.5 2.5V14.5C9.87 14.97 9.5 15.71 9.5 16.5C9.5 17.163 9.76339 17.7989 10.2322 18.2678C10.7011 18.7366 11.337 19 12 19C12.663 19 13.2989 18.7366 13.7678 18.2678C14.2366 17.7989 14.5 17.163 14.5 16.5C14.5 15.71 14.13 15 13.5 14.5V13H17.5V11H13.5V9H17.5V7H13.5V5H17.5V3H13.5V2.5C13.5 2.10218 13.342 1.72064 13.0607 1.43934C12.7794 1.15804 12.3978 1 12 1ZM0.5 15V17C1.17 17 1.29 17.21 1.79 17.71C2.29 18.21 3.17 19 4.5 19C5.83 19 6.71 18.21 7.21 17.71C7.32 17.59 7.41 17.5 7.5 17.41V15.16C6.71 15.42 6.15 15.93 5.79 16.29C5.29 16.79 5.17 17 4.5 17C3.83 17 3.71 16.79 3.21 16.29C2.71 15.79 1.83 15 0.5 15ZM16.5 15V17C17.17 17 17.29 17.21 17.79 17.71C18.29 18.21 19.17 19 20.5 19C21.83 19 22.71 18.21 23.21 17.71C23.71 17.21 23.83 17 24.5 17V15C23.17 15 22.29 15.79 21.79 16.29C21.29 16.79 21.17 17 20.5 17C19.83 17 19.71 16.79 19.21 16.29C18.71 15.79 17.83 15 16.5 15ZM8.5 20C7.17 20 6.29 20.79 5.79 21.29C5.29 21.79 5.17 22 4.5 22C3.83 22 3.71 21.79 3.21 21.29C2.85 20.93 2.29 20.42 1.5 20.16V22.41C1.59 22.5 1.68 22.59 1.79 22.71C2.29 23.21 3.17 24 4.5 24C5.83 24 6.71 23.21 7.21 22.71C7.71 22.21 7.83 22 8.5 22C9.17 22 9.29 22.21 9.79 22.71C10.23 23.14 10.94 23.8 12 23.96C12.16 24 12.33 24 12.5 24C13.83 24 14.71 23.21 15.21 22.71C15.71 22.21 15.83 22 16.5 22C17.17 22 17.29 22.21 17.79 22.71C18.29 23.21 19.17 24 20.5 24C21.83 24 22.71 23.21 23.21 22.71C23.32 22.59 23.41 22.5 23.5 22.41V20.16C22.71 20.42 22.15 20.93 21.79 21.29C21.29 21.79 21.17 22 20.5 22C19.83 22 19.71 21.79 19.21 21.29C18.71 20.79 17.83 20 16.5 20C15.17 20 14.29 20.79 13.79 21.29C13.29 21.79 13.17 22 12.5 22C12.28 22 12.13 21.97 12 21.92C11.72 21.82 11.55 21.63 11.21 21.29C10.71 20.79 9.83 20 8.5 20Z"
                  fill={
                    determineOverheatingColor(
                      Number(
                        metrics?.scan_data?.vehicle_live_data
                          ?.coolant_temperature
                      ),
                      80,
                      91,
                      "fuel"
                    ).iconColor
                  }
                />
                <path
                  d="M12 1C11.6022 1 11.2206 1.15804 10.9393 1.43934C10.658 1.72064 10.5 2.10218 10.5 2.5V14.5C9.87 14.97 9.5 15.71 9.5 16.5C9.5 17.163 9.76339 17.7989 10.2322 18.2678C10.7011 18.7366 11.337 19 12 19C12.663 19 13.2989 18.7366 13.7678 18.2678C14.2366 17.7989 14.5 17.163 14.5 16.5C14.5 15.71 14.13 15 13.5 14.5V13H17.5V11H13.5V9H17.5V7H13.5V5H17.5V3H13.5V2.5C13.5 2.10218 13.342 1.72064 13.0607 1.43934C12.7794 1.15804 12.3978 1 12 1ZM0.5 15V17C1.17 17 1.29 17.21 1.79 17.71C2.29 18.21 3.17 19 4.5 19C5.83 19 6.71 18.21 7.21 17.71C7.32 17.59 7.41 17.5 7.5 17.41V15.16C6.71 15.42 6.15 15.93 5.79 16.29C5.29 16.79 5.17 17 4.5 17C3.83 17 3.71 16.79 3.21 16.29C2.71 15.79 1.83 15 0.5 15ZM16.5 15V17C17.17 17 17.29 17.21 17.79 17.71C18.29 18.21 19.17 19 20.5 19C21.83 19 22.71 18.21 23.21 17.71C23.71 17.21 23.83 17 24.5 17V15C23.17 15 22.29 15.79 21.79 16.29C21.29 16.79 21.17 17 20.5 17C19.83 17 19.71 16.79 19.21 16.29C18.71 15.79 17.83 15 16.5 15ZM8.5 20C7.17 20 6.29 20.79 5.79 21.29C5.29 21.79 5.17 22 4.5 22C3.83 22 3.71 21.79 3.21 21.29C2.85 20.93 2.29 20.42 1.5 20.16V22.41C1.59 22.5 1.68 22.59 1.79 22.71C2.29 23.21 3.17 24 4.5 24C5.83 24 6.71 23.21 7.21 22.71C7.71 22.21 7.83 22 8.5 22C9.17 22 9.29 22.21 9.79 22.71C10.23 23.14 10.94 23.8 12 23.96C12.16 24 12.33 24 12.5 24C13.83 24 14.71 23.21 15.21 22.71C15.71 22.21 15.83 22 16.5 22C17.17 22 17.29 22.21 17.79 22.71C18.29 23.21 19.17 24 20.5 24C21.83 24 22.71 23.21 23.21 22.71C23.32 22.59 23.41 22.5 23.5 22.41V20.16C22.71 20.42 22.15 20.93 21.79 21.29C21.29 21.79 21.17 22 20.5 22C19.83 22 19.71 21.79 19.21 21.29C18.71 20.79 17.83 20 16.5 20C15.17 20 14.29 20.79 13.79 21.29C13.29 21.79 13.17 22 12.5 22C12.28 22 12.13 21.97 12 21.92C11.72 21.82 11.55 21.63 11.21 21.29C10.71 20.79 9.83 20 8.5 20Z"
                  fill={
                    determineOverheatingColor(
                      Number(
                        metrics?.scan_data?.vehicle_live_data
                          ?.coolant_temperature
                      ),
                      80,
                      91,
                      "fuel"
                    ).iconColor
                  }
                />
              </g>
              <defs>
                <clipPath id="clip0_8824_1218">
                  <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div>
            <h4>
              {metrics
                ? parseFloat(
                    metrics?.scan_data?.vehicle_live_data?.coolant_temperature
                  )
                : 0}{" "}
              ℃
            </h4>
            <p>Overheating</p>
          </div>
        </div>

        <div
          className={styles.metrics_card2}
          style={{
            backgroundColor: determineColor(
              parseFloat(
                metrics?.scan_data?.vehicle_live_data?.intake_pressure
              ),
              32,
              33
            ).backgroundColor,
          }}
        >
          <div>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9999 2.40039C6.6983 2.40039 2.3999 6.69879 2.3999 12.0004C2.3999 17.302 6.6983 21.6004 11.9999 21.6004C17.3015 21.6004 21.5999 17.302 21.5999 12.0004C21.5999 6.69879 17.3015 2.40039 11.9999 2.40039ZM11.5202 4.02383V4.80039H12.4796V4.02383C13.5872 4.08962 14.6323 4.37916 15.5733 4.85039L15.1843 5.52539L16.0155 6.00508L16.4077 5.32539C17.3076 5.92081 18.0795 6.69268 18.6749 7.59258L17.9952 7.98477L18.4749 8.81602L19.1499 8.42695C19.6211 9.36799 19.9107 10.4131 19.9765 11.5207H19.1999V12.4801H19.9765C19.9107 13.5877 19.6211 14.6328 19.1499 15.5738L18.4749 15.1848L17.9952 16.016L18.6749 16.4082C18.0795 17.3081 17.3076 18.08 16.4077 18.6754L16.0155 17.9957L15.1843 18.4754L15.5733 19.1504C14.6323 19.6216 13.5872 19.9112 12.4796 19.977V19.2004H11.5202V19.977C10.4126 19.9112 9.3675 19.6216 8.42647 19.1504L8.81553 18.4754L7.98428 17.9957L7.59209 18.6754C6.6922 18.08 5.92032 17.3081 5.3249 16.4082L6.00459 16.016L5.5249 15.1848L4.8499 15.5738C4.37867 14.6328 4.08913 13.5877 4.02334 12.4801H4.7999V11.5207H4.02334C4.08913 10.4131 4.37867 9.36799 4.8499 8.42695L5.5249 8.81602L6.00459 7.98477L5.3249 7.59258C5.92032 6.69268 6.6922 5.92081 7.59209 5.32539L7.98428 6.00508L8.81553 5.52539L8.42647 4.85039C9.3675 4.37916 10.4126 4.08962 11.5202 4.02383ZM16.7999 7.20039L10.7999 10.8004L7.1999 16.8004L13.1999 13.2004L16.7999 7.20039Z"
                fill={
                  determineColor(
                    parseFloat(
                      metrics?.scan_data?.vehicle_live_data?.intake_pressure
                    ),
                    32,
                    33
                  ).iconColor
                }
              />
            </svg>
          </div>
          <div>
            <h4>
              {metrics
                ? parseFloat(
                    metrics?.scan_data?.vehicle_live_data?.intake_pressure
                  )
                : 0}{" "}
              ℃
            </h4>
            <p>Air Intake Pressure</p>
          </div>
        </div>

        <div
          className={styles.metrics_card2}
          style={{
            backgroundColor: determineColor(
              Number(metrics?.scan_data?.vehicle_live_data?.voltage),
              11.5,
              13.1,
              "fuel"
            ).backgroundColor,
          }}
        >
          <div>
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 5.25V7H10.5V5.25H7ZM17.5 5.25V7H21V5.25H17.5ZM3.5 7.875V23.625H24.5V7.875H3.5ZM5.25 9.625H22.75V21.875H5.25V9.625ZM17.5 13.125V14.875H15.75V16.625H17.5V18.375H19.25V16.625H21V14.875H19.25V13.125H17.5ZM7 14.875V16.625H12.25V14.875H7Z"
                fill={
                  determineColor(
                    Number(metrics?.scan_data?.vehicle_live_data?.voltage),
                    11.5,
                    13.1,
                    "fuel"
                  ).iconColor
                }
              />
            </svg>
          </div>
          <div>
            <h4>
              {metrics
                ? parseFloat(metrics?.scan_data?.vehicle_live_data?.voltage)
                : 0}{" "}
              V
            </h4>
            <p>Battery</p>
          </div>
        </div>

        <div
          className={styles.metrics_card2}
          style={{
            backgroundColor: determineColor(
              Number(metrics?.scan_data?.vehicle_live_data?.engine_load),
              29,
              50,
              "engine load"
            ).backgroundColor,
          }}
        >
          <div>
            <svg
              width="29"
              height="28"
              viewBox="0 0 29 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask id="path-1-inside-1_8667_1061" fill="white">
                <path d="M9.83342 11.667H19.1667V21.0003H13.3334L11.0001 18.667H8.66675V12.8337M8.66675 4.66699V7.00033H12.1667V9.33366H8.66675L6.33342 11.667V15.167H4.00008V11.667H1.66675V21.0003H4.00008V17.5003H6.33342V21.0003H9.83342L12.1667 23.3337H21.5001V18.667H23.8334V22.167H27.3334V10.5003H23.8334V14.0003H21.5001V9.33366H14.5001V7.00033H18.0001V4.66699H8.66675Z" />
              </mask>
              <path
                d="M9.83342 11.667H19.1667V21.0003H13.3334L11.0001 18.667H8.66675V12.8337M8.66675 4.66699V7.00033H12.1667V9.33366H8.66675L6.33342 11.667V15.167H4.00008V11.667H1.66675V21.0003H4.00008V17.5003H6.33342V21.0003H9.83342L12.1667 23.3337H21.5001V18.667H23.8334V22.167H27.3334V10.5003H23.8334V14.0003H21.5001V9.33366H14.5001V7.00033H18.0001V4.66699H8.66675Z"
                fill={
                  determineColor(
                    Number(metrics?.scan_data?.vehicle_live_data?.engine_load),
                    29,
                    50,
                    "engine load"
                  ).iconColor
                }
              />
              <path
                d="M19.1667 11.667H19.8334V11.0003H19.1667V11.667ZM19.1667 21.0003V21.667H19.8334V21.0003H19.1667ZM13.3334 21.0003L12.862 21.4717L13.0573 21.667H13.3334V21.0003ZM11.0001 18.667L11.4715 18.1956L11.2762 18.0003H11.0001V18.667ZM8.66675 18.667H8.00008V19.3337H8.66675V18.667ZM8.66675 4.66699V4.00033H8.00008V4.66699H8.66675ZM8.66675 7.00033H8.00008V7.66699H8.66675V7.00033ZM12.1667 7.00033H12.8334V6.33366H12.1667V7.00033ZM12.1667 9.33366V10.0003H12.8334V9.33366H12.1667ZM8.66675 9.33366V8.66699H8.39061L8.19534 8.86225L8.66675 9.33366ZM6.33342 11.667L5.86201 11.1956L5.66675 11.3909V11.667H6.33342ZM6.33342 15.167V15.8337H7.00008V15.167H6.33342ZM4.00008 15.167H3.33341V15.8337H4.00008V15.167ZM4.00008 11.667H4.66675V11.0003H4.00008V11.667ZM1.66675 11.667V11.0003H1.00008V11.667H1.66675ZM1.66675 21.0003H1.00008V21.667H1.66675V21.0003ZM4.00008 21.0003V21.667H4.66675V21.0003H4.00008ZM4.00008 17.5003V16.8337H3.33341V17.5003H4.00008ZM6.33342 17.5003H7.00008V16.8337H6.33342V17.5003ZM6.33342 21.0003H5.66675V21.667H6.33342V21.0003ZM9.83342 21.0003L10.3048 20.5289L10.1096 20.3337H9.83342V21.0003ZM12.1667 23.3337L11.6953 23.8051L11.8906 24.0003H12.1667V23.3337ZM21.5001 23.3337V24.0003H22.1667V23.3337H21.5001ZM21.5001 18.667V18.0003H20.8334V18.667H21.5001ZM23.8334 18.667H24.5001V18.0003H23.8334V18.667ZM23.8334 22.167H23.1667V22.8337H23.8334V22.167ZM27.3334 22.167V22.8337H28.0001V22.167H27.3334ZM27.3334 10.5003H28.0001V9.83366H27.3334V10.5003ZM23.8334 10.5003V9.83366H23.1667V10.5003H23.8334ZM23.8334 14.0003V14.667H24.5001V14.0003H23.8334ZM21.5001 14.0003H20.8334V14.667H21.5001V14.0003ZM21.5001 9.33366H22.1667V8.66699H21.5001V9.33366ZM14.5001 9.33366H13.8334V10.0003H14.5001V9.33366ZM14.5001 7.00033V6.33366H13.8334V7.00033H14.5001ZM18.0001 7.00033V7.66699H18.6667V7.00033H18.0001ZM18.0001 4.66699H18.6667V4.00033H18.0001V4.66699ZM9.83342 12.3337H19.1667V11.0003H9.83342V12.3337ZM18.5001 11.667V21.0003H19.8334V11.667H18.5001ZM19.1667 20.3337H13.3334V21.667H19.1667V20.3337ZM13.8048 20.5289L11.4715 18.1956L10.5287 19.1384L12.862 21.4717L13.8048 20.5289ZM11.0001 18.0003H8.66675V19.3337H11.0001V18.0003ZM9.33342 18.667V12.8337H8.00008V18.667H9.33342ZM8.00008 4.66699V7.00033H9.33342V4.66699H8.00008ZM8.66675 7.66699H12.1667V6.33366H8.66675V7.66699ZM11.5001 7.00033V9.33366H12.8334V7.00033H11.5001ZM12.1667 8.66699H8.66675V10.0003H12.1667V8.66699ZM8.19534 8.86225L5.86201 11.1956L6.80482 12.1384L9.13815 9.80506L8.19534 8.86225ZM5.66675 11.667V15.167H7.00008V11.667H5.66675ZM6.33342 14.5003H4.00008V15.8337H6.33342V14.5003ZM4.66675 15.167V11.667H3.33341V15.167H4.66675ZM4.00008 11.0003H1.66675V12.3337H4.00008V11.0003ZM1.00008 11.667V21.0003H2.33341V11.667H1.00008ZM1.66675 21.667H4.00008V20.3337H1.66675V21.667ZM4.66675 21.0003V17.5003H3.33341V21.0003H4.66675ZM4.00008 18.167H6.33342V16.8337H4.00008V18.167ZM5.66675 17.5003V21.0003H7.00008V17.5003H5.66675ZM6.33342 21.667H9.83342V20.3337H6.33342V21.667ZM9.36201 21.4717L11.6953 23.8051L12.6382 22.8623L10.3048 20.5289L9.36201 21.4717ZM12.1667 24.0003H21.5001V22.667H12.1667V24.0003ZM22.1667 23.3337V18.667H20.8334V23.3337H22.1667ZM21.5001 19.3337H23.8334V18.0003H21.5001V19.3337ZM23.1667 18.667V22.167H24.5001V18.667H23.1667ZM23.8334 22.8337H27.3334V21.5003H23.8334V22.8337ZM28.0001 22.167V10.5003H26.6667V22.167H28.0001ZM27.3334 9.83366H23.8334V11.167H27.3334V9.83366ZM23.1667 10.5003V14.0003H24.5001V10.5003H23.1667ZM23.8334 13.3337H21.5001V14.667H23.8334V13.3337ZM22.1667 14.0003V9.33366H20.8334V14.0003H22.1667ZM21.5001 8.66699H14.5001V10.0003H21.5001V8.66699ZM15.1667 9.33366V7.00033H13.8334V9.33366H15.1667ZM14.5001 7.66699H18.0001V6.33366H14.5001V7.66699ZM18.6667 7.00033V4.66699H17.3334V7.00033H18.6667ZM18.0001 4.00033H8.66675V5.33366H18.0001V4.00033Z"
                fill={
                  determineColor(
                    Number(metrics?.scan_data?.vehicle_live_data?.engine_load),
                    29,
                    50,
                    "engine load"
                  ).iconColor
                }
                mask="url(#path-1-inside-1_8667_1061)"
              />
            </svg>
          </div>
          <div>
            <h4>{metrics?.scan_data?.vehicle_live_data?.engine_load || 0}</h4>
            <p>Eng Load</p>
          </div>
        </div>

        <div
          className={styles.metrics_card2}
          style={{
            backgroundColor: determineColor(
              Number(metrics?.scan_data?.vehicle_live_data?.engine_speed),
              600,
              1500
            ).backgroundColor,
          }}
        >
          <div>
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M26.25 17.5C26.2486 15.1618 25.5709 12.874 24.2988 10.9122L23.0353 12.1765C23.994 13.7868 24.5001 15.626 24.5 17.5H26.25ZM24.5 8.23728L23.2628 7.00003L15.7666 14.4962C15.2332 14.1747 14.6228 14.0033 14 14C13.3078 14 12.6311 14.2053 12.0555 14.5899C11.4799 14.9745 11.0313 15.5211 10.7664 16.1606C10.5015 16.8002 10.4322 17.5039 10.5673 18.1829C10.7023 18.8618 11.0357 19.4854 11.5251 19.9749C12.0146 20.4644 12.6383 20.7977 13.3172 20.9328C13.9961 21.0678 14.6999 20.9985 15.3394 20.7336C15.9789 20.4687 16.5256 20.0201 16.9102 19.4445C17.2947 18.869 17.5 18.1923 17.5 17.5C17.4969 16.8769 17.3255 16.2663 17.0039 15.7325L24.5 8.23728ZM14 19.25C13.6539 19.25 13.3156 19.1474 13.0278 18.9551C12.74 18.7628 12.5157 18.4895 12.3832 18.1697C12.2508 17.85 12.2161 17.4981 12.2836 17.1586C12.3512 16.8192 12.5178 16.5073 12.7626 16.2626C13.0073 16.0179 13.3191 15.8512 13.6586 15.7837C13.9981 15.7161 14.3499 15.7508 14.6697 15.8832C14.9895 16.0157 15.2628 16.24 15.4551 16.5278C15.6474 16.8156 15.75 17.1539 15.75 17.5C15.7496 17.964 15.565 18.4089 15.2369 18.737C14.9089 19.065 14.464 19.2496 14 19.25ZM14 7.00003C15.8736 7.00089 17.7124 7.5069 19.3226 8.46478L20.5949 7.19341C18.746 6.00444 16.6109 5.33575 14.4141 5.25771C12.2173 5.17967 10.04 5.69516 8.11146 6.74994C6.18288 7.80472 4.57423 9.3598 3.45476 11.2516C2.33529 13.1433 1.74639 15.3019 1.75002 17.5H3.50002C3.50326 14.7163 4.61055 12.0474 6.57898 10.079C8.54741 8.11056 11.2162 7.00328 14 7.00003Z"
                fill={
                  determineColor(
                    metrics?.scan_data?.vehicle_live_data?.engine_speed,
                    600,
                    1500
                  ).iconColor
                }
              />
            </svg>
          </div>
          <div>
            <h4>{metrics?.scan_data?.vehicle_live_data?.engine_speed || 0}</h4>
            <p>RPM</p>
          </div>
        </div>

        <div
          className={styles.metrics_card2}
          style={{
            backgroundColor: determineColor(
              Number(metrics?.scan_data?.vehicle_live_data?.speed),
              60,
              120
            ).backgroundColor,
          }}
        >
          <div>
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.63342 6.39651C9.18674 5.09203 11.1042 4.29768 13.1249 4.12151V6.12467C13.1249 6.35674 13.2171 6.5793 13.3812 6.74339C13.5453 6.90749 13.7679 6.99967 13.9999 6.99967C14.232 6.99967 14.4545 6.90749 14.6186 6.74339C14.7827 6.5793 14.8749 6.35674 14.8749 6.12467V4.12151C17.2435 4.33188 19.4576 5.38614 21.114 7.0922C22.7704 8.79827 23.7588 11.0426 23.8991 13.4163H21.8749C21.6429 13.4163 21.4203 13.5085 21.2562 13.6726C21.0921 13.8367 20.9999 14.0593 20.9999 14.2913C20.9999 14.5234 21.0921 14.746 21.2562 14.9101C21.4203 15.0742 21.6429 15.1663 21.8749 15.1663H23.8513C23.5479 17.8637 22.1911 20.1223 20.1553 21.779C19.9752 21.9257 19.8607 22.1379 19.8371 22.3689C19.8135 22.6 19.8826 22.8309 20.0293 23.011C20.1759 23.1911 20.3881 23.3055 20.6192 23.3292C20.8502 23.3528 21.0812 23.2837 21.2613 23.137C23.8583 21.0218 25.5429 18.0107 25.6596 14.4045C25.6674 14.3442 25.6689 14.2832 25.6642 14.2225L25.6666 13.9997C25.6666 7.55618 20.4434 2.33301 13.9999 2.33301C7.55642 2.33301 2.33325 7.55618 2.33325 13.9997C2.33325 17.7937 4.11009 20.946 6.73159 23.13C6.91053 23.272 7.1379 23.3384 7.36512 23.315C7.59235 23.2915 7.80141 23.1802 7.94765 23.0047C8.09388 22.8292 8.1657 22.6035 8.14775 22.3758C8.1298 22.1481 8.02351 21.9364 7.85158 21.786C5.85659 20.1223 4.46475 17.8578 4.15092 15.1663H6.12492C6.35698 15.1663 6.57954 15.0742 6.74364 14.9101C6.90773 14.746 6.99992 14.5234 6.99992 14.2913C6.99992 14.0593 6.90773 13.8367 6.74364 13.6726C6.57954 13.5085 6.35698 13.4163 6.12492 13.4163H4.09959C4.22792 11.2207 5.06908 9.21634 6.39675 7.63317L7.83992 9.07634C8.00579 9.2309 8.22518 9.31505 8.45186 9.31105C8.67855 9.30705 8.89483 9.21522 9.05514 9.0549C9.21546 8.89459 9.30729 8.6783 9.31129 8.45162C9.31529 8.22493 9.23115 8.00555 9.07659 7.83967L7.63342 6.39651ZM19.5533 7.73934C19.4177 7.63493 19.2505 7.57977 19.0794 7.58295C18.9083 7.58613 18.7434 7.64746 18.6118 7.75684L18.3574 7.97034C17.4401 8.74067 16.5259 9.51457 15.6146 10.292C14.8493 10.9453 14.0664 11.622 13.4411 12.1738C13.1703 12.4118 12.9024 12.6529 12.6373 12.8972C12.4642 13.0522 12.3006 13.2173 12.1473 13.3918C11.9663 13.6146 11.8319 13.8714 11.7521 14.1471C11.6723 14.4228 11.6487 14.7116 11.6826 14.9966C11.7166 15.2816 11.8074 15.5568 11.9498 15.806C12.0921 16.0553 12.283 16.2733 12.5113 16.4473C12.976 16.8057 13.5621 16.9689 14.1452 16.9022C14.7283 16.8356 15.2625 16.5443 15.6344 16.0903C15.7371 15.9643 15.8736 15.745 16.0136 15.5105C16.1629 15.2597 16.3461 14.9388 16.5491 14.5795C16.9539 13.8562 17.4451 12.9555 17.9199 12.077C18.4838 11.0305 19.0435 9.98164 19.5988 8.93051L19.7516 8.64001C19.8301 8.49062 19.8533 8.31826 19.817 8.15344C19.7807 7.98861 19.6873 7.84193 19.5533 7.73934Z"
                fill={
                  determineColor(
                    Number(metrics?.scan_data?.vehicle_live_data?.speed),
                    60,
                    120
                  ).iconColor
                }
              />
              <path
                d="M7.63342 6.39651C9.18674 5.09203 11.1042 4.29768 13.1249 4.12151V6.12467C13.1249 6.35674 13.2171 6.5793 13.3812 6.74339C13.5453 6.90749 13.7679 6.99967 13.9999 6.99967C14.232 6.99967 14.4545 6.90749 14.6186 6.74339C14.7827 6.5793 14.8749 6.35674 14.8749 6.12467V4.12151C17.2435 4.33188 19.4576 5.38614 21.114 7.0922C22.7704 8.79827 23.7588 11.0426 23.8991 13.4163H21.8749C21.6429 13.4163 21.4203 13.5085 21.2562 13.6726C21.0921 13.8367 20.9999 14.0593 20.9999 14.2913C20.9999 14.5234 21.0921 14.746 21.2562 14.9101C21.4203 15.0742 21.6429 15.1663 21.8749 15.1663H23.8513C23.5479 17.8637 22.1911 20.1223 20.1553 21.779C19.9752 21.9257 19.8607 22.1379 19.8371 22.3689C19.8135 22.6 19.8826 22.8309 20.0293 23.011C20.1759 23.1911 20.3881 23.3055 20.6192 23.3292C20.8502 23.3528 21.0812 23.2837 21.2613 23.137C23.8583 21.0218 25.5429 18.0107 25.6596 14.4045C25.6674 14.3442 25.6689 14.2832 25.6642 14.2225L25.6666 13.9997C25.6666 7.55618 20.4434 2.33301 13.9999 2.33301C7.55642 2.33301 2.33325 7.55618 2.33325 13.9997C2.33325 17.7937 4.11009 20.946 6.73159 23.13C6.91053 23.272 7.1379 23.3384 7.36512 23.315C7.59235 23.2915 7.80141 23.1802 7.94765 23.0047C8.09388 22.8292 8.1657 22.6035 8.14775 22.3758C8.1298 22.1481 8.02351 21.9364 7.85158 21.786C5.85659 20.1223 4.46475 17.8578 4.15092 15.1663H6.12492C6.35698 15.1663 6.57954 15.0742 6.74364 14.9101C6.90773 14.746 6.99992 14.5234 6.99992 14.2913C6.99992 14.0593 6.90773 13.8367 6.74364 13.6726C6.57954 13.5085 6.35698 13.4163 6.12492 13.4163H4.09959C4.22792 11.2207 5.06908 9.21634 6.39675 7.63317L7.83992 9.07634C8.00579 9.2309 8.22518 9.31505 8.45186 9.31105C8.67855 9.30705 8.89483 9.21522 9.05514 9.0549C9.21546 8.89459 9.30729 8.6783 9.31129 8.45162C9.31529 8.22493 9.23115 8.00555 9.07659 7.83967L7.63342 6.39651ZM19.5533 7.73934C19.4177 7.63493 19.2505 7.57977 19.0794 7.58295C18.9083 7.58613 18.7434 7.64746 18.6118 7.75684L18.3574 7.97034C17.4401 8.74067 16.5259 9.51457 15.6146 10.292C14.8493 10.9453 14.0664 11.622 13.4411 12.1738C13.1703 12.4118 12.9024 12.6529 12.6373 12.8972C12.4642 13.0522 12.3006 13.2173 12.1473 13.3918C11.9663 13.6146 11.8319 13.8714 11.7521 14.1471C11.6723 14.4228 11.6487 14.7116 11.6826 14.9966C11.7166 15.2816 11.8074 15.5568 11.9498 15.806C12.0921 16.0553 12.283 16.2733 12.5113 16.4473C12.976 16.8057 13.5621 16.9689 14.1452 16.9022C14.7283 16.8356 15.2625 16.5443 15.6344 16.0903C15.7371 15.9643 15.8736 15.745 16.0136 15.5105C16.1629 15.2597 16.3461 14.9388 16.5491 14.5795C16.9539 13.8562 17.4451 12.9555 17.9199 12.077C18.4838 11.0305 19.0435 9.98164 19.5988 8.93051L19.7516 8.64001C19.8301 8.49062 19.8533 8.31826 19.817 8.15344C19.7807 7.98861 19.6873 7.84193 19.5533 7.73934Z"
                fill={
                  determineColor(
                    Number(metrics?.scan_data?.vehicle_live_data?.speed),
                    60,
                    120
                  ).iconColor
                }
              />
            </svg>
          </div>
          <div>
            <h4>{metrics?.scan_data?.vehicle_live_data?.speed || 0} Km/H</h4>
            <p>Av. Speed</p>
          </div>
        </div>

        <div
          className={styles.metrics_card2}
          style={{
            backgroundColor: determineColor(
              Number(
                metrics?.scan_data?.vehicle_live_data
                  ?.current_fuel_consumption_rate
              ) /
                parseFloat(
                  metrics?.scan_data?.vehicle_live_data?.vehicle_mileage
                ),
              0.99,
              1
            ).backgroundColor,
          }}
        >
          <div>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.5 15C22.4988 12.9959 21.9179 11.0348 20.8275 9.35328L19.7445 10.437C20.5663 11.8172 21 13.3937 21 15H22.5ZM21 7.06053L19.9395 6.00003L13.5143 12.4253C13.057 12.1498 12.5338 12.0028 12 12C11.4067 12 10.8267 12.176 10.3333 12.5056C9.83996 12.8353 9.45544 13.3038 9.22837 13.852C9.00131 14.4002 8.9419 15.0034 9.05766 15.5853C9.17341 16.1672 9.45914 16.7018 9.87869 17.1213C10.2983 17.5409 10.8328 17.8266 11.4147 17.9424C11.9967 18.0581 12.5999 17.9987 13.1481 17.7717C13.6962 17.5446 14.1648 17.1601 14.4944 16.6667C14.8241 16.1734 15 15.5934 15 15C14.9973 14.4659 14.8504 13.9425 14.5748 13.485L21 7.06053ZM12 16.5C11.7033 16.5 11.4133 16.4121 11.1667 16.2472C10.92 16.0824 10.7277 15.8481 10.6142 15.5741C10.5007 15.3 10.471 14.9984 10.5288 14.7074C10.5867 14.4164 10.7296 14.1491 10.9394 13.9394C11.1491 13.7296 11.4164 13.5867 11.7074 13.5289C11.9983 13.471 12.2999 13.5007 12.574 13.6142C12.8481 13.7277 13.0824 13.92 13.2472 14.1667C13.412 14.4133 13.5 14.7034 13.5 15C13.4996 15.3977 13.3415 15.779 13.0602 16.0603C12.779 16.3415 12.3977 16.4996 12 16.5ZM12 6.00003C13.606 6.00076 15.182 6.43448 16.5623 7.25553L17.6528 6.16578C16.068 5.14666 14.2379 4.5735 12.3549 4.50661C10.4719 4.43972 8.60576 4.88156 6.95268 5.78566C5.29961 6.68976 3.92077 8.02268 2.96123 9.6442C2.00168 11.2657 1.49691 13.1159 1.50001 15H3.00001C3.00279 12.6139 3.9519 10.3264 5.63912 8.63914C7.32635 6.95191 9.61392 6.00281 12 6.00003Z"
                fill={
                  determineColor(
                    Number(
                      metrics?.scan_data?.vehicle_live_data
                        ?.current_fuel_consumption_rate
                    ) /
                      parseFloat(
                        metrics?.scan_data?.vehicle_live_data?.vehicle_mileage
                      ),
                    0.99,
                    1
                  ).iconColor
                }
              />
            </svg>
          </div>
          <div>
            {metrics ? (
              <h4>
                {(
                  parseFloat(
                    metrics?.scan_data?.vehicle_live_data
                      ?.current_fuel_consumption_rate
                  ) /
                  parseFloat(
                    metrics?.scan_data?.vehicle_live_data?.vehicle_mileage
                  )
                ).toFixed(2)}
              </h4>
            ) : (
              <h4>0.00</h4>
            )}{" "}
            <p>Fuel Cons Rate</p>
          </div>
        </div>

        <div className={styles.metrics_card2}>
          <div>
            <svg
              width="20"
              height="20"
              viewBox="0 0 29 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.5 24.5C15.8789 24.5 17.2443 24.2284 18.5182 23.7007C19.7921 23.1731 20.9496 22.3996 21.9246 21.4246C22.8996 20.4496 23.6731 19.2921 24.2007 18.0182C24.7284 16.7443 25 15.3789 25 14C25 12.6211 24.7284 11.2557 24.2007 9.98182C23.6731 8.70791 22.8996 7.55039 21.9246 6.57538C20.9496 5.60036 19.7921 4.82694 18.5182 4.29926C17.2443 3.77159 15.8789 3.5 14.5 3.5C11.7152 3.5 9.04451 4.60625 7.07538 6.57538C5.10625 8.54451 4 11.2152 4 14C4 16.7848 5.10625 19.4555 7.07538 21.4246C9.04451 23.3938 11.7152 24.5 14.5 24.5ZM14.5 26.25C11.2511 26.25 8.13526 24.9594 5.83794 22.6621C3.54062 20.3647 2.25 17.2489 2.25 14C2.25 10.7511 3.54062 7.63526 5.83794 5.33794C8.13526 3.04062 11.2511 1.75 14.5 1.75C17.7489 1.75 20.8647 3.04062 23.1621 5.33794C25.4594 7.63526 26.75 10.7511 26.75 14C26.75 17.2489 25.4594 20.3647 23.1621 22.6621C20.8647 24.9594 17.7489 26.25 14.5 26.25Z"
                fill="#008069"
              />
              <path
                d="M5.75 14C5.75 11.6794 6.67187 9.45376 8.31282 7.81282C9.95376 6.17187 12.1794 5.25 14.5 5.25C16.8206 5.25 19.0462 6.17187 20.6872 7.81282C22.3281 9.45376 23.25 11.6794 23.25 14C23.25 14.2321 23.1578 14.4546 22.9937 14.6187C22.8296 14.7828 22.6071 14.875 22.375 14.875C22.1429 14.875 21.9204 14.7828 21.7563 14.6187C21.5922 14.4546 21.5 14.2321 21.5 14C21.5 12.1435 20.7625 10.363 19.4497 9.05025C18.137 7.7375 16.3565 7 14.5 7C12.6435 7 10.863 7.7375 9.55025 9.05025C8.2375 10.363 7.5 12.1435 7.5 14C7.5 14.2321 7.40781 14.4546 7.24372 14.6187C7.07962 14.7828 6.85706 14.875 6.625 14.875C6.39294 14.875 6.17038 14.7828 6.00628 14.6187C5.84219 14.4546 5.75 14.2321 5.75 14Z"
                fill="#008069"
              />
              <path
                d="M16.0977 17.1676C16.5887 17.5448 16.9306 18.0835 17.0629 18.6884C17.1952 19.2933 17.1094 19.9255 16.8207 20.4733C16.532 21.0211 16.0589 21.4491 15.4851 21.6819C14.9113 21.9146 14.2737 21.937 13.685 21.7451C13.0963 21.5532 12.5944 21.1593 12.2679 20.6331C11.9415 20.107 11.8116 19.4823 11.9011 18.8696C11.9907 18.2569 12.294 17.6956 12.7574 17.2849C13.2207 16.8742 13.8144 16.6405 14.4334 16.6251L16.1012 11.4906C16.1357 11.3802 16.1918 11.2777 16.2663 11.1891C16.3407 11.1005 16.4319 11.0276 16.5348 10.9745C16.6376 10.9214 16.7499 10.8892 16.8652 10.8798C16.9805 10.8704 17.0966 10.884 17.2066 10.9198C17.3167 10.9555 17.4185 11.0128 17.5063 11.0881C17.5941 11.1635 17.666 11.2556 17.718 11.359C17.77 11.4623 17.8009 11.575 17.8091 11.6904C17.8172 11.8058 17.8024 11.9217 17.7654 12.0314L16.0977 17.1659V17.1676ZM14.2287 20.0831C14.3381 20.1187 14.4534 20.1325 14.5681 20.1235C14.6828 20.1146 14.7946 20.0831 14.8971 20.0309C14.9997 19.9788 15.0909 19.9069 15.1657 19.8195C15.2405 19.7321 15.2973 19.6308 15.3329 19.5214C15.3685 19.412 15.3823 19.2966 15.3733 19.1819C15.3644 19.0672 15.3329 18.9554 15.2807 18.8529C15.2286 18.7504 15.1567 18.6591 15.0693 18.5843C14.9819 18.5096 14.8806 18.4527 14.7712 18.4171C14.5502 18.3452 14.3098 18.3639 14.1027 18.4693C13.8956 18.5746 13.7389 18.7579 13.6669 18.9789C13.595 19.1998 13.6137 19.4402 13.7191 19.6473C13.8244 19.8544 14.0077 20.0112 14.2287 20.0831Z"
                fill="#008069"
              />
            </svg>
          </div>
          <div>
            <h4>
              {" "}
              {metrics?.scan_data?.vehicle_live_data?.vehicle_mileage || 0}
            </h4>
            <p>Mileage</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GeneralLiveMetrics;
